export default __webpack_public_path__ + "static/media/split2.06007dcb.jpg";